import { createContext } from 'react'
import type { useCreateShortcutContext } from './useCreateShortcutContext'

export const InternalShortcutContext = createContext<ReturnType<typeof useCreateShortcutContext>>({
  search: {
    handler: { current: undefined },
    setOnSearchInvoked: () => () => {},
    clearOnSearchInvoked: () => {},
  },
  print: {
    handler: { current: undefined },
    setOnPrintInvoked: () => () => {},
    clearOnPrintInvoked: () => {},
  },
  copy: {
    handler: { current: undefined },
    setOnCopyInvoked: () => () => {},
    clearOnCopyInvoked: () => {},
  },
})
